/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Selection_Last_LabelInputs */



/**
* | output |
* | --- |
* | "Last Event" |
*
* @param {Audio_Description_Export_Selection_Last_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_selection_last_label = /** @type {((inputs?: Audio_Description_Export_Selection_Last_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Selection_Last_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dernier événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letztes Ereignis")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ultimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Последнее событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Último evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上次活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम कार्यक्रम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Último evento")
	return /** @type {LocalizedString} */ ("Last Event")
});